import type { OptionLabelPair } from '../../../../components/RadioGroup';
import type { BooleanFlag } from '../../../../types/boolean-flag';
import { BOOLEAN_FLAGS } from '../../../../types/boolean-flag';
import type { SyncDirection } from '../../StripeConfigurationFormSchema';
import { SYNC_DIRECTIONS } from '../../StripeConfigurationFormSchema';

export const SYNC_CUSTOMERS_OPTIONS: OptionLabelPair<SyncDirection>[] = [
  { value: SYNC_DIRECTIONS.SYNC_TO_VAYU, label: 'Sync customers from Stripe to Vayu' },
  { value: SYNC_DIRECTIONS.SYNC_FROM_VAYU, label: 'Sync customers from Vayu to Stripe' },
  { value: SYNC_DIRECTIONS.AUTO_SYNC_DISABLED, label: 'Do not sync automatically' },
];

export const AUTOMATICALLY_SYNC_INVOICES_OPTIONS: OptionLabelPair<BooleanFlag>[] = [
  { value: BOOLEAN_FLAGS.ENABLED, label: 'Automatically sync invoices upon approval (recommended)' },
  { value: BOOLEAN_FLAGS.DISABLED, label: 'Do not sync automatically' },
];

export const SYNC_PAYMENT_REF_OPTIONS: OptionLabelPair<BooleanFlag>[] = [
  { value: BOOLEAN_FLAGS.DISABLED, label: "Don't Sync Payment Ref ID to ERP" },
  { value: BOOLEAN_FLAGS.ENABLED, label: 'Sync Payment Ref ID to ERP' },
];
